export enum TenderStatus {
  AWAITING_RESPONSE = 'AWAITING_RESPONSE',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
  RESPONSE_RECEIVED = 'RESPONSE_RECEIVED',
}
